export const getEditionLabelFragment = (edition: string) => {
  const matcher: Array<[RegExp, string]> = [
    [/free/gi, 'Free'],
    [/standard/gi, 'Standard'],
    [/premium/gi, 'Standard'],
    [/.*/, 'Free']
  ];

  const [, label] = matcher.find(([regex]) => regex.test(edition)) || [];
  return label;
};
